import { z } from 'zod';

// Zod schema for expense category creation form
export const createExpenseCategoryFormSchema = (maxExpenseValue = 100000) =>
  z.object({
    name: z.string().min(1, { message: 'Expense category name is required' }),
    description: z.string().min(1, { message: 'Description is required' }),
    ecmev: z.preprocess(
      (val) => {
        if (val === '' || val === null || val === undefined) return undefined;
        const num = Number(val);
        return isNaN(num) ? undefined : num;
      },
      z
        .number({ required_error: 'ECMEV is required', invalid_type_error: 'ECMEV is required' })
        .min(0, { message: 'Must be a positive number' })
        .max(maxExpenseValue, { message: `ECMEV cannot exceed €${maxExpenseValue.toLocaleString()}` })
    ),
    ecmev_alert_threshold: z.number().min(0).max(100, {
      message: 'Must be between 0 and 100'
    })
  });

export const expenseCategoryFormSchema = createExpenseCategoryFormSchema();

export type ExpenseCategoryFormValues = z.infer<typeof expenseCategoryFormSchema>;

// API interfaces
export interface ExpenseCategoryCreationData {
  name: string;
  description?: string;
  ecmev: number;
  ecmev_alert_threshold: number;
}

export interface ExpenseCategory {
  _id: string;
  user_id: string;
  budget_id: string;
  type: string;
  category: string;
  is_default: boolean;
  name: string;
  description?: string;
  ecmev: number;
  ecmev_committed_amount: number;
  ecmev_alert_threshold: number;
  ecmev_used: number;
  createdAt: string;
  updatedAt: string;
  __v: number;
}
